<template>
	<div class="index">
		<!-- 头部 -->
		<header class="head">
			<HeaderTopView v-bind:num="num"></HeaderTopView>
			<div class="head_logo word flex_start">
				<router-link to="/">
					<i class="head_logoT">
						<img src="@/assets/images/logoT.png" alt />
					</i>
				</router-link>
				<h4>{{$t('Signin.Signin')}}</h4>
			</div>
		</header>
		<!-- 登录信息 -->
		<section class="center word">
			<div class="login_div flex_center">
				<div class>
					<div class="login_l flex_start">
						<div class="login_li flex_between">
							<label for="name">{{$t('Signin.account')}}：</label>
							<input type="text" :placeholder="$t('Signin.mailbox')" v-model="user" />
						</div>
						<div class="login_li flex_between">
							<label for="password">{{$t('Signin.password')}}：</label>
							<input type="password" v-model="password" />
						</div>

						<div class="login-mark">
							<label for="mark">{{$t('Signin.VerificationCode')}}：</label>
							<input type="text" v-model="code" />
							<img :src="imgSrc" alt=" " @click="getMark" />
						</div>

						<div class="login_buttom login_li flex_end">
							<button @click="loginFn">{{$t('Signin.login')}}</button>
						</div>
						<div class="login_a flex_start" @click="modify">
							<a href="javaScript:void(0)">{{$t('Signin.Forgetpassword')}}？</a>
						</div>
					</div>
				</div>
				<div>
					<div class="login_r flex_center">
						<h3>{{$t('Signin.nomember')}}？</h3>
						<h4>{{$t('Signin.Registeredmember')}}</h4>
						<button @click="register">{{$t('Signin.Registernow')}}</button>
					</div>
				</div>
			</div>
		</section>

		<!-- 底部内容 -->
		<Footer></Footer>
	</div>
</template>

<script>
	import "@/assets/css/header.css";
	import HeaderTopView from "@/components/assembly/HeaderTop.vue"; //头部模块
	import Footer from "@/components/assembly/Footer.vue"; //头部模块
	export default {
		name: "home",
		data() {
			return {
				num: "1",
				imgSrc: "",
				user: "",
				password: "",
				loginMark: "", //验证码标识
				code: ""
			};
		},
		components: {
			HeaderTopView,
			Footer
		},
		created() {
			//获取验证码
			this.getMark();
		},
		methods: {
			modify() {
				this.$router.push("/modifyPsd");
			},
			login() {
				this.$router.push("/login");
			},
			register() {
				this.$router.push("/register");
			},
			getMark() {
				let url = "/open/user/getVerifyCode";
				this.$get(url).then(res => {
					this.imgSrc = res.data.base64Str;
					this.loginMark = res.data.loginMark;
				});
			},
			//登录方法
			loginFn() {
				if (!!this.user.trim() && !!this.password.trim() && !!this.code.trim()) {
					this.$post('/open/user/login', {
						code: this.code.trim(),
						loginMark: this.loginMark.trim(),
						email: this.user.trim(),
						password: this.password.trim(),
					}).then(res => {
						if (res.data.token) {
							sessionStorage.setItem('token', res.data.token);
							sessionStorage.setItem('user', JSON.stringify(res.data));
							this.$router.push('/')
						}
					})
				} else {
					this.$message({
						message:this.$t('Tips.perfect'),
						type: "error"
					});
				}
			}
		},

		mounted() {}
	};
</script>

<style scoped>
	/* 头部 */
	.head_logo {
		align-items: center;
	}

	.head_logo h4 {
		font-size: 16px;
		color: #1a1a1a;
		margin-left: 27px;
	}

	/* 登录框 */
	.center .login_div {
		max-width: 980px;
		margin: 68px auto;
		height: 400px;
		background: #fff;
		border: 1px solid #e2e2e2;
		position: relative;
	}

	.center .login_div::after {
		content: "";
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		top: 25px;
		width: 1px;
		height: 300px;
		background: #e2e2e2;
	}

	.center .login_div>div {
		width: 50%;
	}

	.center .login_div .login_l {
		flex-direction: column;
		width: 68%;
		margin: 0 auto;
	}

	.center .login_div .login_l .login_li {
		margin-top: 24px;
		width: 100%;
	}

	.center .login_div .login_l .login_li label {
		font-size: 15px;
		width: 50%;
		color: #1a1a1a;
	}

	.center .login_div .login_l .login_li input {
		width: calc(100% - 78px);
		height: 32px;
		padding: 0 4px;
		font-size: 15px;
		border: 1px solid #e2e2e2;
	}
	
	.login-mark {
		margin-top: 24px;
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 15px;
		color: #1a1a1a;
	}
	.login-mark > label {
		width: 58%;
	}
	.login-mark>input {
		width: 45%;
		height: 32px;
		padding: 0 4px;
		border: 1px solid #e2e2e2;
	}

	.login-mark img {
		width: 30%;
		height: 32px;
	}

	.login_buttom>button {
		width: calc(100% - 52px);
		height: 36px;
		background-image: linear-gradient(180deg, #3f9fea, #0573cb);
		color: #fff;
		font-size: 15px;
	}

	.login_a {
		margin-top: 24px;
		padding-left: 52px;
		text-align: left;
	}

	.login_a a {
		display: inline-block;
		font-size: 15px;
		color: #0875cc;
	}

	.login_r {
		flex-direction: column;
		width: 59%;
		margin: 0 auto;
	}

	.login_r h3 {
		font-size: 26px;
		color: #1a1a1a;
		line-height: 1em;
	}

	.login_r h4 {
		font-size: 14px;
		color: #666;
		line-height: 1em;
		margin-top: 11px;
	}

	.login_r>button {
		width: 100%;
		height: 36px;
		background: #02082c;
		color: #fff;
		margin-top: 44px;
		font-size: 15px;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue